import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import SwiperCore, {Pagination, EffectFade, Autoplay} from 'swiper/core';
import {ApiService} from 'src/app/services/api/api.service';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-progress',
    templateUrl: './pb-progress.component.html',
    styleUrls: ['./pb-progress.component.scss']
})

export class PbProgressComponent implements OnInit {

    @Input() module: any = {};
    slides: any = [];
    swiperInstance: any;

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        // freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        centerInsufficientSlides: true,
        pagination: {clickable: true},
        breakpoints: {
            576: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 3.2
            },
            992: {
                slidesPerView: 4
            }
        }
    };


    constructor(private api: ApiService, private cd: ChangeDetectorRef) {}

    ngOnInit(): void {

        this.fetchProgress();

    }

    /**
     * When the 'Why Study with us' swiper is ready, then run the update so that the slide size is correct
     * @param swiper
     */
    onProgressSwiper(swiper) {

        this.swiperInstance = swiper;

        setTimeout(() => {
            //  swiper.update();
        }, 1500);

    }

    /**
     * Fetches Progress items
     */
    async fetchProgress() {

        await this.api.fetch_progress()
            .subscribe(res => {
                this.slides = res.data.items;
                this.slides.forEach((item, index) => {
                    this.slides[index].description = JSON.parse(item.description);
                });
                this.slides = this.slides.filter(item => item.published);
                this.cd.detectChanges();
            }, (err) => {
                console.log(err);
            });

    }

}